import * as React from 'react'

const SvgWhiteBookIcon = (props) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99935 16.5L9.91597 16.3749C9.3371 15.5066 9.04767 15.0725 8.66527 14.7582C8.32673 14.4799 7.93665 14.2712 7.51735 14.1438C7.04372 14 6.52194 14 5.47837 14H4.33268C3.39926 14 2.93255 14 2.57603 13.8183C2.26243 13.6586 2.00746 13.4036 1.84767 13.09C1.66602 12.7335 1.66602 12.2668 1.66602 11.3333V4.16667C1.66602 3.23325 1.66602 2.76654 1.84767 2.41002C2.00746 2.09641 2.26243 1.84144 2.57603 1.68166C2.93255 1.5 3.39926 1.5 4.33268 1.5H4.66602C6.53286 1.5 7.46628 1.5 8.17932 1.86331C8.80652 2.18289 9.31646 2.69282 9.63604 3.32003C9.99935 4.03307 9.99935 4.96649 9.99935 6.83333M9.99935 16.5V6.83333M9.99935 16.5L10.0827 16.3749C10.6616 15.5066 10.951 15.0725 11.3334 14.7582C11.672 14.4799 12.062 14.2712 12.4813 14.1438C12.955 14 13.4768 14 14.5203 14H15.666C16.5994 14 17.0661 14 17.4227 13.8183C17.7363 13.6586 17.9912 13.4036 18.151 13.09C18.3327 12.7335 18.3327 12.2668 18.3327 11.3333V4.16667C18.3327 3.23325 18.3327 2.76654 18.151 2.41002C17.9912 2.09641 17.7363 1.84144 17.4227 1.68166C17.0661 1.5 16.5994 1.5 15.666 1.5H15.3327C13.4658 1.5 12.5324 1.5 11.8194 1.86331C11.1922 2.18289 10.6822 2.69282 10.3627 3.32003C9.99935 4.03307 9.99935 4.96649 9.99935 6.83333"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgWhiteBookIcon
